import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ReservationActionTypesEnum } from '@api/ringil-api.v2';
import InputSelectMultiple from '@components/ringil3/Input/InputSelect/InputSelectMultiple';

interface ComponentProps {
  loadingTypes: ReservationActionTypesEnum[];
  onChange: (loadingTypes: ReservationActionTypesEnum[]) => void;
  mandatory?: boolean;
  dataTestIdPrefix?: string;
}

const InputManipulationType: React.FC<ComponentProps> = ({ loadingTypes, onChange, mandatory, dataTestIdPrefix }) => {
  const { tr } = useTranslationLgs();

  return (
    <div className={'pb-1.5'}>
      <InputSelectMultiple
        model={[
          {
            label: tr('InputManipulationType.loading', 'Loading'),
            code: ReservationActionTypesEnum.LOADING,
          },
          {
            label: tr('InputManipulationType.unloading', 'Unloading'),
            code: ReservationActionTypesEnum.UNLOADING,
          },
        ]}
        selectedItemCodes={loadingTypes}
        mandatory={mandatory}
        onSelect={v => onChange(v.map(item => item as ReservationActionTypesEnum))}
        dataTestIdPrefix={dataTestIdPrefix}
      />
    </div>
  );
};

export default InputManipulationType;
